import React, { Component } from "react";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import _ from "i18n";
import {
  initFilterClient,
  setFilterBusinessUnit,
  setFilterClient,
  setFilterClientGroup,
  setFilterCluster,
  setFilterCollaborators,
  setFilterSquads,
  setDynamicTableFilterYear,
  setDynamicTableSearchWord,
  setDynamicTableSortBy,
  setClientType,
  setClientCRMType,
  setClientCRMGroup,
  setClientsDeletedStatus,
  setClientsOffshoreStatus,
  setIsEntityClientsState,
  setDynamicTableCollaboratorRole,
  setPageSizeState,
  setClientsFacturableStatus
} from "Actions";
import {
  fetchBusinessUnitSuggestions,
  fetchClusterSuggestions,
  fetchCollaboratorSuggestions,
  fetchDynamicTableData,
  fetchDynamicTableCollaborators,
  fetchSquadsSuggestions
} from "Thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
// import { renderYearsArrayBetween } from "Utils";
import styles from "./DynamicTable.local.scss";
import {
  DYNAMIC_TABLE_SORT_TYPES,
  DELETED_STATUS,
  OFFSHORE_STATUS,
  CLIENT_GROUP_CRM_FILTER,
  CLIENT_CRM_TYPE_FILTER,
  NEW_COLLABORATOR_ROLE_FILTER,
  CLIENT_FACTURABLE_STATUS_FILTER
} from "Config";
import moment from "moment";
import { dispatch } from "rxjs/internal/observable/pairs";

class DynamicTableFilter extends Component {
  constructor(props) {
    super(props);
    this.sortOptions = Object.keys(DYNAMIC_TABLE_SORT_TYPES).map(roleType => {
      return {
        label: _(roleType),
        options: DYNAMIC_TABLE_SORT_TYPES[roleType].map(({ value, label }) => {
          return { label: _(label), value: value };
        })
      };
    });
    this.loadCollaboratorSuggestions = debounce(
      this.loadCollaboratorSuggestions,
      1000
    );
    this.loadSquadSuggestions = debounce(this.loadSquadSuggestions, 1000);
    this.loadClusterSuggestions = debounce(this.loadClusterSuggestions, 1000);
    this.loadBusinessUnitSuggestions = debounce(
      this.loadBusinessUnitSuggestions,
      1000
    );
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);

    this.state = {
      expandedYearsDiv: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  setYearsWrapperRef(node) {
    this.wrapperYearsRef = node;
  }

  handleDisplayYearSelectItems = () => {
    let { expandedYearsDiv } = this.state;

    if (expandedYearsDiv === false) {
      this.setState({ expandedYearsDiv: true });
    } else {
      this.setState({ expandedYearsDiv: false });
    }
  };

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperYearsRef && !this.wrapperYearsRef.contains(event.target)) {
      this.setState({ expandedYearsDiv: false });
    }
  }

  renderYearsLabel = () => {
    let { selectedYear } = this.props;
    return selectedYear instanceof Array ? "2022" : selectedYear;
  };

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleRefreshDynamicTable = () => {
    const { dispatch } = this.props;
    dispatch(fetchDynamicTableData());
  };

  handleClientGroupChange = selected => {
    // let groups = selected.map(element => element.value);
    this.props.dispatch(setFilterClientGroup(selected));
    this.props.dispatch(initFilterClient());
    this.handleRefreshDynamicTable();
  };

  handleClientChange = selected => {
    this.props.dispatch(setFilterClient(selected));
    this.handleRefreshDynamicTable();
  };

  handleCollaboratorChange = selected => {
    // let collaborators = selected.map(element => element.value);
    this.props.dispatch(setFilterCollaborators(selected));
    this.handleRefreshDynamicTable();
  };

  handleYearsChange = selected => {
    const { dispatch } = this.props;
    dispatch(setDynamicTableFilterYear(selected));
    dispatch(fetchDynamicTableCollaborators());
    this.setState({ expandedYearsDiv: false });
  };

  handleSortChange = selected => {
    this.setState(() => {
      this.props.dispatch(setDynamicTableSortBy(selected));
      this.handleRefreshDynamicTable();
    });
  };

  handleSquadChange = selected => {
    this.props.dispatch(setFilterSquads(selected));
    this.handleRefreshDynamicTable();
  };

  handleClusterChange = selected => {
    this.props.dispatch(setFilterCluster(selected));
    this.handleRefreshDynamicTable();
  };

  handleBusinessUnitChange = selected => {
    this.props.dispatch(setFilterBusinessUnit(selected));
    this.handleRefreshDynamicTable();
  };

  handleSearchInputChange(word) {
    this.props.dispatch(setDynamicTableSearchWord(word));
    this.handleRefreshDynamicTable();
  }

  handleTypeClientChange = selected => {
    this.props.dispatch(setClientType(selected));
    this.handleRefreshDynamicTable();
  };

  handleGroupCRMClientChange = selected => {
    this.props.dispatch(setClientCRMGroup(selected));
    this.handleRefreshDynamicTable();
  };

  handleTypeCRMClientChange = selected => {
    this.props.dispatch(setClientCRMType(selected));
    this.handleRefreshDynamicTable();
  };

  handleCollaboratorRoleChange = selected => {
    this.props.dispatch(setDynamicTableCollaboratorRole(selected));
    this.handleRefreshDynamicTable();
  };

  handleSetDeletedStatus = selectedStatus => {
    this.props.dispatch(setClientsDeletedStatus(selectedStatus));
    this.handleRefreshDynamicTable();
  };

  handleSetIsEntityState = isEntity => {
    this.props.dispatch(setIsEntityClientsState(isEntity));
    this.handleRefreshDynamicTable();
  };

  handleSetOffshoreStatus = selectedStatus => {
    this.props.dispatch(setClientsOffshoreStatus(selectedStatus));
    this.handleRefreshDynamicTable();
  };

  handleFacturableStatutChange = selectedStatus => {
    this.props.dispatch(setClientsFacturableStatus(selectedStatus));
    this.handleRefreshDynamicTable();
  };

  loadSquadSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchSquadsSuggestions(searchWord))
      .then(res => {
        const squads = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(squads);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadClusterSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClusterSuggestions(searchWord))
      .then(res => {
        const clusters = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(clusters);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadBusinessUnitSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchBusinessUnitSuggestions(searchWord))
      .then(res => {
        const businessUnits = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(businessUnits);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const collaborators = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  renderYearsSelect = years => {
    const { expandedYearsDiv } = this.state;
    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (expandedYearsDiv === true ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{this.renderYearsLabel()}</span>
          <div className={styles.year_actions}>
            <div>
              <span
                className={styles.year_action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={
                    expandedYearsDiv === true
                      ? "icon icon-arrow-up"
                      : "icon icon-arrow-down"
                  }
                />
              </span>
            </div>
          </div>
        </div>
        {expandedYearsDiv === true && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((year, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleYearsChange(year)}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleListPageSizeChange = selected => {
    this.props.handleDynamicTablePageSize(selected);
    this.props.dispatch(setPageSizeState(selected));
  };

  render() {
    let {
      financialSheetFilter,
      listFilters,
      // currentOrganization,
      filter,
      resultCount,
      pageSize
    } = this.props;
    let yearsOption = [];
    let year = moment().year();
    let years = [
      year - 1 + "/" + (year - 2),
      year - 1 + "/" + (year - 1),
      year + "/" + (year - 1),
      year + "/" + year
    ];
    // currentOrganization.startDate && currentOrganization.startDate.date
    //   ? renderYearsArrayBetween(
    //       currentOrganization.startDate.date,
    //       new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    //     )
    //   : renderYearsArrayBetween(
    //       new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    //       new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    //     );
    years.forEach(item => {
      yearsOption.push({ value: item, label: item });
    });

    let filters = [
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("sortBy"),
          options: this.sortOptions,
          action: this.handleSortChange,
          values: financialSheetFilter.sortBy.selected
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: filter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          values: filter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.squads.selected,
          placeholder: _("squad"),
          handleChange: this.handleSquadChange,
          loadSuggestions: this.loadSquadSuggestions,
          values: financialSheetFilter.squads.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.cluster.selected,
          placeholder: _("Cluster"),
          handleChange: this.handleClusterChange,
          loadSuggestions: this.loadClusterSuggestions,
          values: financialSheetFilter.cluster.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.businessUnit.selected,
          placeholder: _("BU"),
          handleChange: this.handleBusinessUnitChange,
          loadSuggestions: this.loadBusinessUnitSuggestions,
          values: financialSheetFilter.businessUnit.selected
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientState"),
          options: DELETED_STATUS,
          values: listFilters.entityClientId.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("Offshore status"),
          options: OFFSHORE_STATUS,
          values: listFilters.entityClientId.offshoreStatus,
          action: this.handleSetOffshoreStatus
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("Statut Facturable"),
          options: CLIENT_FACTURABLE_STATUS_FILTER,
          values: listFilters.entityClientId.facturableStatus,
          action: this.handleFacturableStatutChange
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.collaborator.selected,
          placeholder: _("collaborator"),
          handleChange: this.handleCollaboratorChange,
          loadSuggestions: this.loadCollaboratorSuggestions,
          values: financialSheetFilter.collaborator
        }
      },
      financialSheetFilter.collaborator.selected.length > 0 && {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("Dossiers En tant que"),
          options: NEW_COLLABORATOR_ROLE_FILTER,
          values: filter.collaboratorRole,
          action: this.handleCollaboratorRoleChange
        }
      }
    ];

    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            label={_("folderNumber")}
            nbResult={resultCount > 0 ? resultCount - 1 : resultCount}
            marginLeft={"0.5em"}
            button
            filters={filters}
            customAddOn={this.renderYearsSelect(years)}
            handleResetFilter={this.handleResetFilter}
            searchPlaceholder="Search by name or erp id"
            searchInputValue={financialSheetFilter.searchWord.searchWord}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            pageSize={pageSize}
            handleListPageSizeChange={this.handleListPageSizeChange}
            cssClass="medium-12"
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  financialSheetFilter: state.financialSheet.periodFilter,
  currentOrganization: state.auth.currentOrganization,
  selectedYear: state.budget.dynamicTable.filter.year,
  resultCount: state.budget.dynamicTable.resultCount,
  budgetState: state.budget.dynamicTable.filter.budgetState,
  listFilters: state.clients.filter,
  filter: state.financialSheet.periodTree.filter
});

export default connect(mapStateToProps)(DynamicTableFilter);



// WEBPACK FOOTER //
// ./src/components/DynamicTable/DynamicTableFilter.js